import { MenuItem, Select } from "@mui/material"
import { IBuildingSelection } from "../../models/dashboard"

interface BuildingSelectProps {
    buildingId: number,
    setBuildingId : Function,
    buildingSelections : IBuildingSelection[] | undefined | null
}

const BuildingSelect = ({buildingId, setBuildingId, buildingSelections }:BuildingSelectProps) => {

    return(
        <Select
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            value={buildingId}
            onChange={(event) => setBuildingId(event.target.value as number)}
        >
            {buildingSelections?.map((building) => <MenuItem key={building.id} value={building.id}>{building.name}</MenuItem>)}
        </Select>
    )
}

export default BuildingSelect;